import { institutionalApi } from "./index";
import { RootState } from "app/store";
import { IUser, IUserNotification } from "interfaces";
import { FlagEnum } from "interfaces/enums";

export const userApi = institutionalApi.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query<IUser, any>({
      //@ts-ignore
      // Transform user
      queryFn: async (_arg, { getState }, _extraOptions, fetchWithBQ) => {
        const { auth } = getState() as RootState;
        if (auth?.token) {
          const result = await fetchWithBQ("/user");
          const user = result.data as IUser;
          // user.flags = [
          //   FlagEnum.api_access,
          //   //FlagEnum.ccy_conversion_super_broker,
          //   FlagEnum.ccy_conversion_broker,
          //   FlagEnum.mex_dollar_admin,
          // ];
          return {
            ...result,
            data: {
              ...user,
              isRouterUser: user?.flags.includes(
                FlagEnum.ccy_conversion_client,
              ),
              isRouterBroker: user?.flags.includes(
                FlagEnum.ccy_conversion_broker,
              ),
              isSuperBroker: user?.flags.includes(
                FlagEnum.ccy_conversion_super_broker,
              ),
            },
          };
        }
        return new Promise((resolve) => resolve);
      },
      providesTags: ["User"],
    }),
    createUser: builder.mutation({
      query: (params) => ({
        url: "/user",
        method: "POST",
        headers: {
          authorization: params.token,
        },
        body: {
          name_first: params.firstName,
          name_last: params.lastName,
          // phone: params.phone,
          email: params.email,
          password: params.password,
          recaptcha: params.recaptcha,
          accepted_terms: true,
          flags: params.flags,
          referral_code: params.referralCode ?? "",
        },
      }),
    }),
    acceptTerms: builder.mutation<string, undefined>({
      query: () => ({
        url: "/user/accept_terms",
        method: "POST",
      }),
      invalidatesTags: ["User"],
    }),
    superBrokerUsers: builder.query<{ [key in string]: string }, undefined>({
      query: () => ({
        url: "/router/super_broker/groups",
        method: "GET",
      }),
      providesTags: ["SuperUserBroker"],
    }),
    getUserNotifications: builder.query<Array<IUserNotification>, undefined>({
      query: () => ({
        url: "/user/notifications",
        method: "GET",
      }),
      providesTags: ["UserNotifications"],
    }),
    readUserNotification: builder.mutation<void, string>({
      query: (notification_id) => ({
        url: "/user/notifications/read",
        method: "POST",
        body: { notification_id },
      }),
      invalidatesTags: ["UserNotifications"],
    }),
  }),
});

export const {
  useGetUserQuery,
  useSuperBrokerUsersQuery,
  useCreateUserMutation,
  useAcceptTermsMutation,
  useGetUserNotificationsQuery,
  useReadUserNotificationMutation,
} = userApi;
